export const actionTypes = {
  SET_CUSTOM_ONBOARDING: "SET CUSTOM ONBOARDING",
  SET_SUB_MODAL: "SET SUB MODAL",
  SET_VARIABLES: "SET VARIABLES",
  SET_TEMPDATA: "SET TEMP DATA",
  DISMISS_HINT: "DISMISS HINT",
  SET_QUICK_ACCESS: "SET QUICK ACCESS",
  SEE_TICKET: "SEE TICKET",
  SEE_ORG_WELCOME: "SEE ORG WELCOME",
  SET_LIST_VIEW: "SET LIST VIEW",
  TOGGLE_PROJECT_PIN: "TOGGLE PROJECT PIN",
  VISIT_PROJECT: "VISIT PROJECT",
};

export const actions = {
  setCustomOnboarding: (data) => ({
    type: actionTypes.SET_CUSTOM_ONBOARDING,
    payload: data,
  }),
  setTempData: (data) => ({
    type: actionTypes.SET_TEMPDATA,
    payload: data,
  }),
  setSubModal: (data) => ({
    type: actionTypes.SET_SUB_MODAL,
    payload: data,
  }),
  setVariables: (data) => ({
    type: actionTypes.SET_VARIABLES,
    payload: data,
  }),

  dismissHint: (key) => ({
    type: actionTypes.DISMISS_HINT,
    payload: key,
  }),

  setQuickAccess: (scopeKey, state) => ({
    type: actionTypes.SET_QUICK_ACCESS,
    payload: { scopeKey, state },
  }),

  /* Records the reply a ticket was last read at, so the support badge can tell
   * "answered" apart from "answered and already seen". */
  seeTicket: (uuid, lastReplyAt) => ({
    type: actionTypes.SEE_TICKET,
    payload: { uuid, lastReplyAt },
  }),

  /* Marks the one-time welcome for an organization as shown. Owners get it
   * stamped when they finish the setup wizard, so the only people who ever see
   * the welcome are the colleagues they invited. */
  seeOrgWelcome: (uuid) => ({
    type: actionTypes.SEE_ORG_WELCOME,
    payload: uuid,
  }),

  /* Pin a project to the sidebar, or take it off. Kept per organization so
   * switching workspaces does not surface another one's shortcuts.
   *
   * `project` is stored whole ({ uuid, title, image }) rather than as an id:
   * the sidebar then needs no lookup, so a pinned project shows up even when it
   * is not on the first page of the projects list — which is the flat-dump
   * problem this replaces. */
  toggleProjectPin: (orgUuid, project) => ({
    type: actionTypes.TOGGLE_PROJECT_PIN,
    payload: { orgUuid, project },
  }),

  /* Opening a project is what makes it recent. */
  visitProject: (orgUuid, project) => ({
    type: actionTypes.VISIT_PROJECT,
    payload: { orgUuid, project },
  }),

  /* Cards or table, per module. Kept per module rather than globally because
   * the right default differs: a roster of people reads as cards, a ledger of
   * time entries does not. */
  setListView: (module, view) => ({
    type: actionTypes.SET_LIST_VIEW,
    payload: { module, view },
  }),
};
